import {
    useState,
    forwardRef,
    useImperativeHandle,
    createRef,
} from 'react'

import DataElement from '../DataElement'

const genUid = () => `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`

export default forwardRef(({ title, titlePlural, attributes, data, addButtonText, readOnly }, ref) => {

    const [listData, setListData] = useState((data || []).map(d => ({
        ...d,
        uid: genUid(),
    })))

    const [elementRefs, setElementRefs] = useState(listData.map(_ => createRef()))

    const addElement = () => {
        const uid = genUid()
        setListData(prev => [...prev, { uid }])
        setElementRefs([...elementRefs, createRef()])
    }

    const removeElement = (index) => {
        setListData(prev => prev.filter((_, i) => i !== index))
        setElementRefs(elementRefs.filter((_, i) => i !== index))
    }

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {
            const elementResults = elementRefs.map((elementRef) => elementRef.current.validateAndGetData())

            const error = elementResults.some((result) => !result.isValid)

            const isValid = !error

            return {
                isValid,
                value: elementResults.map(element => element.value),
            }

        },
    }))

    return (
        <div className="space-y-4">
            <h2 className="text-lg font-semibold">{titlePlural}</h2>

            {elementRefs.map((elementRef, index) => (
                <div key={listData[index].uid} className="p-4 border rounded-md space-y-3 bg-gray-50">
                    <h3 className="text-md font-semibold">{title} {index + 1}</h3>
                    {/* Render the DataElement component with the attributes and data */}

                    <DataElement ref={elementRef} attributes={attributes} data={listData[index]} readOnly={readOnly} />

                    {
                        !readOnly && (
                            <button
                                type="button"
                                onClick={() => removeElement(index)}
                                className="mt-2 px-3 py-1 bg-red-500 text-white rounded-md hover:bg-red-600"
                            >
                                Remove
                            </button>
                        )
                    }

                </div>
            ))}

            {
                !readOnly && (
                    <div className="flex justify-end">
                        <button
                            type="button"
                            onClick={addElement}
                            className="px-3 py-1 bg-green-500 text-white rounded-md hover:bg-green-600 ml-auto"
                        >
                            {addButtonText || `Add a different ${title}`}
                        </button>
                    </div>
                )
            }



        </div>
    )

})
